import { useState } from 'react';
import { Button } from '@mui/material';

// ICONOS
import AddCircleIcon from '@mui/icons-material/AddCircle';

// COMPONENTES
import CrearIncidencia from './modales/CrearIncidencia';

const LogIncidents = () => {

    const [isOpen, setIsOpen] = useState(false);

    return (

        <div>

            <Button
                variant="contained"
                color="primary"
                startIcon={<AddCircleIcon />}
                onClick={() => setIsOpen(true)}
            >
                Nuevo Incidente
            </Button>

            <CrearIncidencia
                open={isOpen}
                onClose={() => setIsOpen(false)}
            />

        </div>

    )

}

export default LogIncidents